import React, { useEffect } from 'react'
import Browsebanner from './Browsebanner'

import Evolve from '../landing/Evolvetomi/Evolve'
import Footer from '../landing/footer/Footer'
import Workbuild from './Workbuild'
import Benfitsbuild from './Benfitsbuild'
import Faqsbuildpath from './faqsbuildgroup/Faqsbuildpath'
import GetappBuild from '../Chatandpay/getapp/GetappBuildGroup'


const Buildgroup = () => {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
  useEffect(() => {
    document.title = "Decentralized Communities - tomi  ";
  
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", "Build and manage your own decentralized group with secure messaging and payments, allowing you to transact as naturally as you chat - tomi");
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = "Build and manage your own decentralized group with secure messaging and payments, allowing you to transact as naturally as you chat - tomi";
      document.head.appendChild(meta);
    }
  }, []);
  return (
    <>
      <Browsebanner />
      <Benfitsbuild />
      <Workbuild />
      <Faqsbuildpath/>
      <Evolve />
      <GetappBuild />
      <Footer />
    </>
  )
}

export default Buildgroup